import { Button } from '@material-ui/core';
import React from 'react';
import { ResponsiveDialogActions, ResponsiveDialogProps } from '../dialog';

interface IProps extends ResponsiveDialogProps {
  saveText: string;
  isSubmitting: boolean;
}

const CancelSaveBtns: React.FC<IProps> = ({
  onClose,
  isSubmitting,
  saveText,
}) => {
  return (
    <ResponsiveDialogActions>
      <Button
        className='orangeLink'
        data-cy='cancel'
        disabled={isSubmitting}
        onClick={onClose}
      >
        CANCEL
      </Button>

      <Button
        color='secondary'
        data-cy='changePassword'
        disabled={isSubmitting}
        type='submit'
      >
        {saveText}
      </Button>
    </ResponsiveDialogActions>
  );
};

export default CancelSaveBtns;
